export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-skull-aab5c668f8c72d26c4b9bf0cf7a60c5c.svg";